import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/apps/pauljohnson/src/app/_media/paul-headshot-small.png");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/avatar/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/backgrounds/sparkles.tsx");
